import React from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import { map } from "lodash";
import { positionText } from "../../../../utils/tips";
import "./TableUsers.scss";

function getRoleLabel(user) {
  if (user.is_superuser) return "Súper Usuario";
  if (user.is_staff) return "Admin";
  return user.can_charge ? "Estándar · cobra en caja" : "Estándar";
}

// Persona registrada que no entra al sistema (limpieza, etc.).
function getLoginLabel(user) {
  return user.can_login === false ? " · sin acceso" : "";
}

export function TableUsers(props) {
  const { users, updateUser, onDeleteUser } = props;

  return (
    <Table className="table-users-admin">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Username</Table.HeaderCell>
          <Table.HeaderCell>Email</Table.HeaderCell>
          <Table.HeaderCell>Nombre</Table.HeaderCell>
          <Table.HeaderCell>Apellidos</Table.HeaderCell>
          <Table.HeaderCell>Puesto</Table.HeaderCell>
          <Table.HeaderCell>Activo</Table.HeaderCell>
          <Table.HeaderCell>Rol</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {map(users, (user, index) => (
          <Table.Row key={index}>
            <Table.Cell>{user.username}</Table.Cell>
            <Table.Cell>{(user.email || "").endsWith("@sin-acceso.local") ? "—" : user.email}</Table.Cell>
            <Table.Cell>{user.first_name}</Table.Cell>
            <Table.Cell>{user.last_name}</Table.Cell>
            {/* Puesto (reparto de propinas); un Admin puede no tenerlo. */}
            <Table.Cell>{user.position ? positionText(user.position) : "—"}</Table.Cell>
            <Table.Cell className="status">
              {user.is_active ? <Icon name="check" /> : <Icon name="close" />}
            </Table.Cell>
            <Table.Cell>{getRoleLabel(user)}{getLoginLabel(user)}</Table.Cell>

            <Actions
              user={user}
              updateUser={updateUser}
              onDeleteUser={onDeleteUser}
            />
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

function Actions(props) {
  const { user, updateUser, onDeleteUser } = props;

  return (
    <Table.Cell textAlign="right">
      <Button icon onClick={() => updateUser(user)}>
        <Icon name="pencil" />
      </Button>
      <Button icon negative onClick={() => onDeleteUser(user)}>
        <Icon name="close" />
      </Button>
    </Table.Cell>
  );
}
